module.exports = __webpack_public_path__ + "static/3BHK-01-Living-room-4f3fca962058eda2951e9408a771754b.jpg";